import React from 'react';
import { Modal } from 'antd';
import Loader from '../Loader';

function BusyModal({
  isLoading, isError, onClose, onErrorClose,
}) {
  const isVisible = isLoading || isError;
  const title = isError && 'Error';

  const errorMessage = 'Something went wrong. Please try again.';

  const footerOverride = isLoading ? { footer: null } : {};

  return (
    <Modal
      title={title}
      visible={isVisible}
      closable={false}
      loading
      cancelButtonProps={{ hidden: true }}
      okButtonProps={{ hidden: !isError }}
      onOk={onErrorClose || onClose}
      destroyOnClose
      {...footerOverride}
    >
      {isLoading ? <Loader isLoading /> : errorMessage}
    </Modal>
  );
}

export default BusyModal;
